module.exports = __webpack_public_path__ + "static/media/img_tailor.3ef9487d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/solution/images/img_tailor.png
// module id = 390
// module chunks = 4